import axios from "axios";
import Cookies from "js-cookie";

export async function createCsrfAndGetCookie() {
    const csrfInstance = axios.create();
    await csrfInstance.get(`${process.env.VUE_APP_API_URL.split("admin/")[0]}app/csrf`, {
        params: {
            ts: new Date().getTime(),
        },
    });
    const tokenName = process.env.VUE_APP_CSRF_COOKIE_NAME;
    if (Cookies.get(tokenName)) return Cookies.get(tokenName);
    return null;
}

export async function insertInstanceRules(instance) {
    let hasInstance = false;
    const tokenName = process.env.VUE_APP_CSRF_COOKIE_NAME;
    if (!Cookies.get(tokenName)) {
        setTimeout(async () => {
            const csrfCookie = await createCsrfAndGetCookie();
            if (csrfCookie) {
                instance.defaults.headers.common["X-CSRF-TOKEN"] = csrfCookie;
                axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfCookie;
            }
        }, 1);
    }

    instance.interceptors.request.use(
        async function (config) {
            let headers = config.headers;
            if (!Object.keys(instance.defaults.headers.common).includes("X-CSRF-TOKEN") && !hasInstance) {
                hasInstance = true;
                const csrfCookie = await createCsrfAndGetCookie();
                if (csrfCookie) {
                    instance.defaults.headers.common["X-CSRF-TOKEN"] = csrfCookie;
                    axios.defaults.headers.common["X-CSRF-TOKEN"] = csrfCookie;
                }
                hasInstance = false;
            }
            config.headers = {...headers, ...instance.defaults.headers.common};
            return config;
        },
        function (error) {
            return Promise.reject(error);
        }
    );
}